import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";

const InterviewDetailsCard = ({ details }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 1px 3px rgba(0, 0, 0, 0.3)"
            : "0px 1px 3px rgba(0, 0, 0, 0.1)",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, mb: 1, color: theme.palette.text.primary }}
        >
          IGNA Scout Details
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr", lg: "1fr 1fr" },
            gap: { xs: 1, sm: 1.5, lg: 2.5 },
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              Interview Date
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
            >
              {details.date}
            </Typography>
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              Total Duration
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
            >
              {details.duration}
            </Typography>
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              Questions Answered
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
            >
              {details.questionsAnswered}
            </Typography>
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              Total Behaviour Score
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
            >
              {details.totalBehaviourScore != null ? details.totalBehaviourScore : "-"}
            </Typography>
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              sx={{ mb: 0.5 }}
            >
              Total AI Score
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: theme.palette.text.primary, overflowWrap: "anywhere" }}
            >
              {details.totalAiScore != null ? details.totalAiScore : "-"}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default InterviewDetailsCard;
